import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=0be0e035&scoped=true&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=0be0e035&scoped=true&lang=css&"
import style1 from "./UserProfile.vue?vue&type=style&index=1&id=0be0e035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be0e035",
  null
  
)

export default component.exports